
/**
 * Normalize properties to pass to analytics.js
 *
 * @param {Object} workspace
 * @return {Object}
 * @api public
 */

export function normalizeWorkspace (workspace) {
  return {
    workspace_id: workspace.id,
    workspace_name: workspace.name,
    workspace_slug: workspace.slug,
    workspace_created_date: workspace.created
  }
}



// WEBPACK FOOTER //
// ./lib/analytics/index.js